import { Module } from 'vuex-smart-module';
import SubpartnersActions from './actions';
import SubpartnersGetters from './getters';
import SubpartnersMutations from './mutations';
import SubpartnersState from './state';
import SubpartnersSales from './modules/subpartner-sales';

export default new Module({
  state: SubpartnersState,
  mutations: SubpartnersMutations,
  actions: SubpartnersActions,
  getters: SubpartnersGetters,
  modules: {
    subpartner_sales: SubpartnersSales,
  },
});
